<ng-select [(ngModel)]="selected" (ngModelChange)="onModelChanged($event)" [disabled]="isDisabled" [multiple]="multiple"
           [placeholder]="'hx.invoice-select.placeholder.chooseInvoice' | transloco" [clearable]="true">
  <ng-option *ngFor="let op of options" [value]="op.id">№{{op.number}} {{ 'hx.invoice-select.from' | transloco }} {{op.incomingInvoiceDate}}</ng-option>
</ng-select>
